import React from 'react';

import { Drawer } from 'antd';
import cn from 'classnames';

import I18n from '@utils/i18n';

import styles from './index.module.less';

export const DrawerBtn = ({
  isPc,
  deleteRows,
  submitHandle,
  cancelHandle,
  selectAll,
  showEdit,
  selectedRowKeys = []
}) => {
  return (
    <Drawer
      visible={showEdit}
      closable={false}
      mask={false}
      height="80px"
      placement="bottom"
      className={styles.drawer}
    >
      <div className={styles.drawerContainer}>
        <div className={styles.btnContainer}>
          <div className={styles.editTableBtn} onClick={selectAll}>
            {I18n.t('KrljOszQ')}
          </div>
          <div
            className={cn(styles.editTableBtn, styles.deleteBtn, {
              [styles.disabled]: !selectedRowKeys.length
            })}
            onClick={deleteRows}
          >
            {I18n.t('deleteConfirm')}
          </div>
        </div>
        <div className={styles.btnContainer}>
          <div className={styles.editTableBtn} onClick={cancelHandle}>
            {I18n.t('forceUpdate.cancel')}
          </div>
          <div
            className={cn(styles.editTableBtn, styles.okBtn)}
            onClick={submitHandle}
          >
            {I18n.t('ok')}
          </div>
        </div>
      </div>
    </Drawer>
  );
};
